export default __webpack_public_path__ + "static/media/cupify-padded-mailer.f3ff0441.png";